import { render, staticRenderFns } from "./AtividadeTabList.vue?vue&type=template&id=58616b58&scoped=true"
import script from "./AtividadeTabList.vue?vue&type=script&lang=js"
export * from "./AtividadeTabList.vue?vue&type=script&lang=js"
import style0 from "./AtividadeTabList.vue?vue&type=style&index=0&id=58616b58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58616b58",
  null
  
)

export default component.exports